import {
  LoadAvailableTelsFailurePayload,
  LoadAvailableTelsSuccessPayload,
  LoadTelsFilter,
} from '../models/AvailableTels';
import { SimManagementError } from '../models/Errors';
import { Action } from './';
import {
  CLEAR_AVAILABLE_TELS,
  ENSURE_AVAILABLE_TELS,
  LOAD_AVAILABLE_TELS_FAILURE,
  LOAD_AVAILABLE_TELS_PENDING,
  LOAD_AVAILABLE_TELS_SUCCESS,
} from './actionTypes';

export function clearAvailableTels() {
  return {
    type: CLEAR_AVAILABLE_TELS,
  };
}

export function ensureAvailableTels(payload: LoadTelsFilter) {
  return {
    type: ENSURE_AVAILABLE_TELS,
    payload,
  };
}

export function loadAvailableTelsPending(payload: LoadTelsFilter) {
  return {
    type: LOAD_AVAILABLE_TELS_PENDING,
    payload,
  };
}

export function loadAvailableTelsSuccess(payload: LoadAvailableTelsSuccessPayload) {
  return {
    type: LOAD_AVAILABLE_TELS_SUCCESS,
    payload,
  };
}

export function loadAvailableTelsFailure(
  filter: LoadTelsFilter,
  error: SimManagementError,
): Action<LoadAvailableTelsFailurePayload> {
  return {
    type: LOAD_AVAILABLE_TELS_FAILURE,
    payload: {
      filter,
      error,
    },
  };
}
